type entry = {title: string, imageurl: string, imdms: {x: number, y: number}, description: string[]}
export const tabs: entry[] = [
{title: "DEMO REEL", imageurl: "https://www.youtube.com/embed/MO7Qn6GVxOk?si=AtlpWwSw9IGACIwr", 
imdms: {x: 560, y:315}, description:
["Programs used: Maya, Blender, Ibispaint, Desmos","",
"A short compilation of my recent animation work including independent films,",
"group / class projects, and ani-mathematical experiments."]},

{title: "MAYA", imageurl: "https://www.youtube.com/embed/ZS8z87411Uw?si=mHcHJ9nW7UPJ6JvL",
imdms: {x: 560, y:315},
description:
["Programs used: Blender, GuitarPro","",
"An independent short film I created for my Intermediate Computer Animation Final Project.",
"It started as a breakup song I wrote about Autodesk's Maya 3D and slowly",
"evolved into an entire music video. I learned a lot more about Blender's rigging constraints",
"while creating the mechanical protagonist of the film."]},

{title: "RUN, CYCLE", imageurl: "https://player.vimeo.com/video/782695057?badghe=0&amp;quality_selector=1&amp;player_id=0&amp", 
imdms: {x: 560, y:315}, description:
["Programs used: Maya, Blender","",
"A short film I created with a group of three for my Beginner Computer Animation Final Project.",
"We started with a simple narrative, then pushed the visual style as far into abstraction as we could.",
"We scored the film over the course of three days, splicing together audio from late night jam sessions."]},

{title: "THE COLOR OF MORNING", imageurl: "https://www.youtube.com/embed/CbLNqFFxN1I?si=J_SyjhdqMD5a_TX7", 
imdms: {x: 560, y:315}, description:
["Programs used: Ibispaint, Procreate","",
"A dance film I created with my friend Daniel Carroll for my Dance Theater Workshop piece / Senior Initiative.",
"Because of the pandemic, we were unable to perform our works in person- I took advantage of this limitation",
"and decided to hand-animate my dance. Daniel and I spent 8 hours a day illustrating each frame of the film",
"for a span of three and a half months until the film's completion. Daniel used Procreate on his iPad,",
"while I used IbisPaint on my phone."]},

{title: "FOUR LINE CONICS", imageurl: "https://www.youtube.com/embed/2oySNv1ySd8?si=9M2RhVH5paO0D14X", 
imdms: {x: 560, y:315}, description:
["Programs used: Desmos, Blender, GuitarPro, Controlnet","",
"The longest short film yet I've ever created. I pieced it together over the span of three weeks while teaching at",
"a math program known as HCSSiM (Hampshire Summer Studies in Mathematics). It is a parody of the cult classic",
"math movie \"Four Line Conics\" by the National Film Board of Canada, which features psychedelic animations of",
"conic sections. I rendered a majority of the film using mathematical equations in Desmos Graphing Calculator",
"and composed an original song in 5/4 for the score."]},

{title: "UPDRAFTS", imageurl: "https://www.youtube.com/embed/YMU8VBZGe20?si=kn6zNC-rD_Qv-qSk", 
imdms: {x: 560, y:315}, description:
["Programs used: Maya, Blender","",
"A 6 minute long short film I am currently working on with a team of 12.",
"The story centers around a father struggling to understand his daughter through her art.",
"I worked on the story and character design during the preproduction phase, and am currently",
"shooting live action for / animating the film's scenes in Maya."]},

{title: "REEL", imageurl: "https://www.youtube.com/embed/du700_k7zZo?si=ApV-4skyg0pRh4rK", 
    imdms: {x: 560, y:315}, description:
    ["Programs used: Rive","",
    "A 6.5 minute long piece I created with Rive, an animation software primarily used for making interactive",
    "website UI elements. I thought it could be a fun challenge to make a short film with this software, ",
    "especially since it had never been done before."]}
]